import script from "./RenderDoc.vue?vue&type=script&setup=true&lang=js"
export * from "./RenderDoc.vue?vue&type=script&setup=true&lang=js"

import "./RenderDoc.vue?vue&type=style&index=0&id=1eeaa308&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1eeaa308"]])

export default __exports__